import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest, API_PREFIX } from 'utils/api'
import axios from 'axios'

// ============ Get App Version ============
export const GET_APP_VERSION = 'GET_APP_VERSION'
export const getAppVersion = () => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_APP_VERSION)())
    sendApiRequest('Settings/app-version', {
      accessToken: getState().auth.account.accessToken
    }, 'get').then((response) => {
      if (response.status === 'failure') {
        dispatch(getAppVersionError(response))
      }
      if (response.status === 'success') {
        dispatch(getAppVersionSuccess(response.data))
      }
    })
  }
}

export const GET_APP_VERSION_SUCCESS = 'GET_APP_VERSION_SUCCESS'
export const getAppVersionSuccess = createAction(GET_APP_VERSION_SUCCESS)

export const GET_APP_VERSION_ERROR = 'GET_APP_VERSION_ERROR'
export const getAppVersionError = createAction(GET_APP_VERSION_ERROR)

// ============ Upload App Version ============
export const UPLOAD_APP_VERSION = 'UPLOAD_APP_VERSION'
export const UPLOAD_APP_VERSION_PROGRESS = 'UPLOAD_APP_VERSION_PROGRESS'
export const uploadAppVersionProgress = createAction(UPLOAD_APP_VERSION_PROGRESS)

export const uploadAppVersion = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(UPLOAD_APP_VERSION)())
    const accessToken = getState().auth.account.accessToken

    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('version', data.version)
    formData.append('releaseNotes', data.releaseNotes || '')

    const url = `${API_PREFIX}Settings/app-version/upload?filter={}&where={}&access_token=${accessToken}`

    axios({
      method: 'post',
      url,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        dispatch(uploadAppVersionProgress(percentCompleted))
      }
    })
      .then((response) => {
        // axios resolves on 2xx status, so if we get here it's successful
        dispatch(uploadAppVersionSuccess(response.data))
        dispatch(getAppVersion())
      })
      .catch((error) => {
        const errorData = error.response?.data?.error || { message: error.message || 'Upload request failed' }
        dispatch(uploadAppVersionError({ data: errorData }))
      })
  }
}

export const UPLOAD_APP_VERSION_SUCCESS = 'UPLOAD_APP_VERSION_SUCCESS'
export const uploadAppVersionSuccess = createAction(UPLOAD_APP_VERSION_SUCCESS)

export const UPLOAD_APP_VERSION_ERROR = 'UPLOAD_APP_VERSION_ERROR'
export const uploadAppVersionError = createAction(UPLOAD_APP_VERSION_ERROR)

export const UPLOAD_APP_VERSION_RESET = 'UPLOAD_APP_VERSION_RESET'
export const uploadAppVersionReset = createAction(UPLOAD_APP_VERSION_RESET)

// ============ Dialog State ============
export const OPEN_UPLOAD_DIALOG = 'OPEN_UPLOAD_DIALOG'
export const openUploadDialog = createAction(OPEN_UPLOAD_DIALOG)

export const CLOSE_UPLOAD_DIALOG = 'CLOSE_UPLOAD_DIALOG'
export const closeUploadDialog = createAction(CLOSE_UPLOAD_DIALOG)

// ============ Initial State ============
const initialState = {
  appVersion: null,
  isLoadingVersion: false,
  loadVersionError: null,
  isUploading: false,
  hasUploaded: false,
  uploadError: null,
  uploadProgress: 0,
  uploadDialogOpen: false
}

// ============ Reducer ============
export default handleActions({
  [GET_APP_VERSION]: (state) => ({
    ...state,
    isLoadingVersion: true,
    loadVersionError: null
  }),
  [GET_APP_VERSION_SUCCESS]: (state, { payload }) => ({
    ...state,
    isLoadingVersion: false,
    appVersion: payload
  }),
  [GET_APP_VERSION_ERROR]: (state, { payload }) => ({
    ...state,
    isLoadingVersion: false,
    loadVersionError: payload
  }),
  [UPLOAD_APP_VERSION]: (state) => ({
    ...state,
    isUploading: true,
    hasUploaded: false,
    uploadError: null,
    uploadProgress: 0
  }),
  [UPLOAD_APP_VERSION_PROGRESS]: (state, { payload }) => ({
    ...state,
    uploadProgress: payload
  }),
  [UPLOAD_APP_VERSION_SUCCESS]: (state) => ({
    ...state,
    isUploading: false,
    hasUploaded: true,
    uploadError: null
  }),
  [UPLOAD_APP_VERSION_ERROR]: (state, { payload }) => ({
    ...state,
    isUploading: false,
    hasUploaded: false,
    uploadError: payload
  }),
  [UPLOAD_APP_VERSION_RESET]: (state) => ({
    ...state,
    isUploading: false,
    hasUploaded: false,
    uploadError: null
  }),
  [OPEN_UPLOAD_DIALOG]: (state) => ({
    ...state,
    uploadDialogOpen: true
  }),
  [CLOSE_UPLOAD_DIALOG]: (state) => ({
    ...state,
    uploadDialogOpen: false,
    hasUploaded: false,
    uploadError: null,
    uploadProgress: 0
  })
}, initialState)
